import React, { useState } from "react";
import apiClient from "../api/apiClient"; // your axios instance
import "../styles/styles.css";

const CancelRide = () => {
  const [rideId, setRideId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCancelRide = async () => {
    if (!rideId) {
      alert("Please enter a Ride ID");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token"); // get token from localStorage

      const res = await apiClient.put(`/admin/${rideId}/cancel`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert(res.data); // show API response message in popup
    } catch (err) {
      if (err.response && err.response.data) {
        alert(`Error: ${err.response.data}`);
      } else {
        alert("Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container-cancelride">
      <div className="login-card porter-theme" style={{ maxWidth: "400px" }}>
        <h2>Cancel Ride</h2>

        <div className="input-group">
          <label>Ride ID</label>
          <input
            type="number"
            placeholder="Enter Ride ID"
            value={rideId}
            onChange={(e) => setRideId(e.target.value)}
          />
        </div>

        <button
          className="btn-primary"
          onClick={handleCancelRide}
          disabled={loading}
        >
          {loading ? "Cancelling..." : "Cancel Ride"}
        </button>
      </div>
    </div>
  );
};

export default CancelRide;
